import React, { FC, ReactNode } from "react";
import { useClient } from "ClientContext";
import StaySearchForm from "components/HeroSearchForm/(stay-search-form)/StaySearchForm";
import { useTranslation } from "react-i18next";
import { useGetListings } from "hooks/useGetListings";

interface GuestySearchComponentProps {
  className?: string;
  listingType?: ReactNode;
  onSearch: (value: any) => void;
}

const GuestySearchComponent: FC<GuestySearchComponentProps> = ({
  className = "",
  listingType,
  onSearch,
}) => {
  const { heroImg, requestType, } = useClient();
const {totalListings} = useGetListings();
  const { t } = useTranslation();

  return (
    <div
      className={`nc-SectionHeroArchivePage ${requestType==="ALL_CALENDAR_LISTINGS" && "h-[250px]"} flex flex-col relative ${className}`}
      data-nc-id="SectionHeroArchivePage"
    >
      <div className="flex flex-col lg:flex-row lg:items-center ">
        {/* Left Section */}
        <div className="flex-shrink-0 lg:w-1/2 space-y-6 lg:space-y-10 pb-14 lg:pb-64 xl:pb-80 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl leading-[110%]">
            {t("Book Your Stay")}
          </h2>
          <div className="flex items-center text-base md:text-lg text-neutral-500 dark:text-neutral-400">
            <i className="las la-map-marked-alt"></i>
            <span className="ml-2.5">{t("Find Your Perfect Escape")}</span>
            {listingType || (
              totalListings > 0 && (
                <span className="mx-5 flex items-center">
                  <i className="text-2xl las la-home"></i>
                  <span className="ml-2.5">{totalListings} {t("Option(s)")}</span>
                </span>
              )
            )}
          </div>
        </div>

        {/* Right Section */}
  
          <div className="hidden sm:flex sm:flex-grow">
            <img className="w-full" src={heroImg} alt="hero" />
          </div>
      </div>

      {/* Search Form */}
        <div className="hidden lg:block w-full lg:-mt-40 xl:-mt-56">
          <StaySearchForm onSearch={onSearch} />
        </div>
      
    </div>
  );
};

export default GuestySearchComponent;